export class Format {
  static formatTimeToText(time: number): string {
    let min = Math.trunc(time / 60);
    let sec = Math.trunc(time % 60);
    let minutes = min < 10 ? '0' + min : min;
    let seconds = sec < 10 ? '0' + sec : sec;

    let duration = `${minutes}:${seconds}`;

    return duration
  }

  static formatStringDateToIso(date: string) : string {
    const day = date.substring(0, 2);
    const month = date.substring(3, 5);
    const year = date.substring(6);

    return `${year}-${month}-${day}`
  }

/**
 * @param date Data a ser convertida.
 * @returns yyyy-mm-dd.
 */
  static dateToInvertedStringFormat(date: Date) : string;
  static dateToInvertedStringFormat(date: undefined) : null;
  static dateToInvertedStringFormat(date: Date | undefined): string | null;
  static dateToInvertedStringFormat(date: Date | undefined) {
    if (date == undefined || isNaN(date.getTime())) {
      return null
    }
    const offset = date.getTimezoneOffset()
    date = new Date(date.getTime() - (offset*60*1000))
    return date.toISOString().split('T')[0]
  }

  static dateToDayMonthYear(date: Date) {
    const inverterdString = Format.dateToInvertedStringFormat(date);
    const [y , m , d] = inverterdString.split('-')
    return `${d}-${m}-${y}`
  }

}
